<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VqzWvt/tc-custom/9781646564514.jpg?1723405516456" alt="This image is the cover for the book Jack's Back, Indiscreet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jack's Back, Indiscreet
      </h1>
      <p class="bookDescription body article font2">
        <p>Jim Menetti had a life at Indiscreet, the Gay BDSM club owned by Bear Drummond and Reed Davis. His life revolves around Reed, his Master, and his position as manager of the Club.<br/><br/>On Jim and Reed's third anniversary, Jack Leary, Reed's on and off flame comes back and Jim's relationship with Reed unravels.<br/><br/>He picks himself up and makes a life for himself apart from his job, buys a home, makes it into a cozy retreat, and gets a cat he names Waltzing Matilda. He even has a new love interest, the mysterious Professor Caleb Brickner, an expert in the Spanish Inquisition and medieval torture.<br/><br/>Then Reed changes his mind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.C. Katt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2eb4176a